<template>
  <div class="form-group">
    <div class="d-flex">
      <span v-if="isFloating && prefix" class="prefix">{{ prefix }}</span>
      <input
        :class="{ highlight: isFloating }"
        :id="getRailsIdFromFieldName(name)"
        :name="name"
        :required="required"
        :type="type"
        @blur="inputFocused = false"
        @focus="inputFocused = true"
        @input="e => input(e)"
        :value="value"
        class="form-control privacy flex-grow-1"
      />
    </div>
    <label :for="getRailsIdFromFieldName(name)" :class="{ float: isFloating }">{{ label }}</label>
  </div>
</template>

<script>
import getRailsIdFromFieldName from "../mixins/getRailsIdFromFieldName";

export default {
  name: "FormInputFloatingLabel",
  mixins: [getRailsIdFromFieldName],
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      inputFocused: false,
    };
  },
  computed: {
    isFloating: {
      get() {
        return this.inputFocused || !!this.value;
      },
      set(bool) {
        this.inputFocused = bool;
      },
    },
  },
  methods: {
    input(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

input {
  bottom: 0;
  border: 0;
  border-bottom: $btn-focus-width solid $input-border-color;
  margin-top: 1rem;
  padding: $spacer-1 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  min-width: 0;

  &:hover {
    border-bottom-color: $input-focus-border-color;
  }
}

label {
  @include truncate;

  top: $bottom-position-float-label;
  color: $input-placeholder-color;

  font-size: $font-size-sm;
  margin: 0;
  position: absolute;
  z-index: $zi-medium;
  font-weight: normal;
  transition: top $transition-duration-short linear, font-size $transition-duration-short linear;
  cursor: text;
}

.float {
  color: $input-focus-border-color;
  top: 0;
}

.highlight {
  border-bottom-color: $input-focus-border-color;
}

.prefix {
  padding: $spacer-1 $spacer-1/4 $spacer-1 0;
  font-size: $input-font-size;
  border-bottom: $btn-focus-width solid $input-focus-border-color;
  line-height: $line-height-base;
  margin-top: 1rem;
}
</style>
